import React, { Component } from 'react';
import { SubMenuLink } from "../../SubMenuLink";

export default class OtherEbox extends Component {

  render() {
    return <SubMenuLink cssClass={"other-ebox"} pathname="/other-ebox" title="find other E-box" icon="OTHER_EBOX_LIGHT" />;
  }
};
